import store from '@store/index.js'
import repo from '@repo/repo.js'

export const navigationLog = async (to, from, failure) => {
    if (!!failure) return

    if (!to.name || !from.name || to.name === 'login') return

    const personId = store.getters.currentPerson?.id
    const venueId = store.getters.currentVenue?.id
    const profileId = store.getters.currentProfile?.id

    repo.post('analytics/navigation', {
        url: to.fullPath,
        route: to.name,
        fromUrl: from.fullPath,
        fromRoute: from.name,
        personId,
        venueId,
        profileId,
    })

    return 1
}
